var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    [
      _vm.loading
        ? _c("KioskSpinner")
        : _c(
            "div",
            { class: _vm.$style.payment },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.paymentIcon,
                attrs: { symbol: "card-icon" }
              }),
              _vm._v(" "),
              _c("h2", { class: _vm.$style.totalPrice }, [
                _vm._v(_vm._s(_vm._f("toPrice")(_vm.totalPrice)))
              ]),
              _vm._v(" "),
              _c("p", { class: _vm.$style.paymentText }, [
                _vm._v("Insert, or Swipe card when ready")
              ]),
              _vm._v(" "),
              _c(
                "BaseButton",
                {
                  class: _vm.$style.cancelBtn,
                  attrs: { "button-style": "Danger" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("\n      Cancel\n    ")]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskPayment.vue?vue&type=template&id=76ad8d28&
// module id = null
// module chunks = 